import React from 'react';
import { OfferBar } from './components/OfferBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PromptExplainer } from './components/PromptExplainer/PromptExplainer';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-white text-plum" data-id="element-0" data-mp="2wjqhr811w6n6">
      <MetaPixel data-id="element-1" data-mp="28u5y0mx2p5cu" />
      <OfferBar data-id="element-2" data-mp="28tmex2vosax8" />
      {/* Spacer matching the fixed offer bar height */}
      <div className="h-[56px]" aria-hidden="true" data-id="element-3" data-mp="23vci6nubd29i" />
      <main data-id="element-4" data-mp="23utcc5hxu4bu">
        <Hero data-id="element-5" data-mp="23v2sl1d6kx4c" />
        <Stats data-id="element-6" data-mp="23ti864kkyuk7" />
        <Testimonials data-id="element-7" data-mp="3ik7gwiph6frp" />
        <PainPoints data-id="element-8" data-mp="3ikqy1x7ax04o" />
        <Volumes data-id="element-9" data-mp="3ij61y35c994p" />
        <Bonuses data-id="element-10" data-mp="3ijpet5g4t7bv" />
        <Pricing data-id="element-11" data-mp="3ii4q3wgi0ilx" />
        <PromptExplainer data-id="element-12" data-mp="3mlat8v8bdto6" />
        <FAQ data-id="element-13" data-mp="3mkho1yp07c85" />
        <ValueStack data-id="element-14" data-mp="3mjzs7369700r" />
      </main>
      <Footer data-id="element-15" data-mp="3mj6jhwnqi0fz" />
    </div>;
}